import React from 'react'
import { useSelectOptions } from 'transfix-form/hooks'
import { Select, ISelectProps } from 'transfix-ui/components/Select'
import { useCommoditiesQuery } from './graphql/Commodity'

export interface ICommodityTypeSelectProps extends Omit<ISelectProps, 'options'> {}

export const CommodityTypeSelect = ({ ...SelectProps }: ICommodityTypeSelectProps) => {
  const { data } = useCommoditiesQuery({})
  const { commodities = [] } = data || {}

  const { options = [] } = useSelectOptions({
    options: commodities,
    mapOption: ({ description: label, id: value }) => ({ label, value }),
  })

  return <Select label='Commodity Type' options={options} {...SelectProps} />
}

export default CommodityTypeSelect
